<template>
  <div class="web-news" :class="{'web-no':((newsObj.p0!==$store.state.sys.p0Video || newsObj.p0!==$store.state.sys.p0VideoShu) && (newsObj.smallImage=='' || newsObj.smallImage==null)) || (newsObj.p0==$store.state.sys.p0Imgs && !isFromHome)}"
    @click="goDetails(newsObj.id, newsObj.p0, newsObj.webUrl)">
    <div class="web-news-img web-bg-img">
      <img :src="newsObj.smallImage" alt="">
      <div class="web-mark" v-if="newsObj.p0==$store.state.sys.p0Video || newsObj.p0==$store.state.sys.p0VideoShu">
        <div class="web-mark-bottom">
          <img src="../assets/images/common/play.png" alt="" class="web-play">
        </div>
      </div>
    </div>
    <div class="web-news-message" :class="{'web-imgs':newsObj.p0==$store.state.sys.p0Imgs && !isFromHome}">
      <div class="web-news-title" :class="hasInfo?'ellipsis':'ellipsis2'">{{newsObj.title}}</div>
      <div class="web-news-describe ellipsis2" v-if="hasInfo">{{newsObj.description}}</div>
      <div class="web-news-imgs-box clear" :class="{'hasInfo':hasInfo==true}" v-if="newsObj.p0==$store.state.sys.p0Imgs && !isFromHome">
        <div class="web-news-imgs web-bg-img lf" v-for="(item,index) in newsObj.images" :key="index">
          <img :src="item.image" alt="">
        </div>
      </div>
      <div class="web-news-info ellipsis" :class="{'hasInfo':hasInfo==true}">
        <span>{{newsObj.source}}</span>
        <span>{{newsObj.publishDate}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "cms-news",
    props: {
      newsObj: {
        type: Object
      },
      // hasInfo: {
      //   type: Boolean,
      //   default: false
      // },
      canClick: {
        type: Boolean,
        default: true
      },
      isFromHome: {
        type: Boolean,
        default: false
      },
      // 生活圈同城生活-公告信息
      noticeLink: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        hasInfo: false
      }
    },
    mounted() {

    },
    methods: {
      goDetails(id, p0, webUrl) {
        if (this.canClick) {
          if (this.noticeLink) {
            // 跳转同城生活-信息公告
            if (id) {
              if (p0 == this.$store.state.sys.p0Url) {
                // 跳转链接
                if (webUrl) {
                  window.open(webUrl, '_blank');
                } else {
                  this.errorMessage("外部链接地址为空");
                }
              } else {
                let path = "/live/noticedetails";
                this.$store.dispatch("setNewsId", id);
                this.$router.push({
                  name: path,
                  params: id
                })
              }
            }
          } else {
            this.skipNewsDetials(id, p0, webUrl);
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-news {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
  }

  .web-news-img {
    width: 214px;
    height: 120px;
    position: relative;
  }

  .web-news-imgs {
    width: 200px;
    height: 112px;
    margin-right: 5px;
    margin-top: 10px;
  }

  .web-news-imgs-box.hasInfo .web-news-imgs {
    width: 240px;
    height: 135px;
    margin-right: 10px;
  }

  .web-news-imgs-box.hasInfo .web-news-imgs:nth-child(3n),
  .web-news-imgs:nth-child(3n) {
    margin-right: 0;
  }

  .web-news-message {
    width: -moz-calc(100% - 226px);
    width: -webkit-calc(100% - 226px);
    width: calc(100% - 226px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .web-news-title {
    line-height: 30px;
    font-size: 20px;
    font-family: Source Han Sans CN Bold;
    color: #333333;
  }

  .web-news-info {
    height: 27px;
    line-height: 27px;
    font-size: 18px;
    color: #666666;
    margin-top: 33px;
  }

  .web-news-info span {
    margin-left: 19px;
  }

  .web-news-info span:first-child {
    margin-left: 0;
  }

  .web-no .web-news-img {
    display: none;
  }

  .web-no .web-news-message {
    width: 100%;
  }

  .web-no .web-news-info {
    margin-top: 30px;
  }

  .web-no .web-imgs .web-news-info {
    margin-top: 10px;
  }

  /* 有描述 */
  .web-news-title.ellipsis {
    height: 30px;
  }

  .web-news-describe {
    height: 42px;
    font-size: 18px;
    color: #595757;
    line-height: 21px;
    margin-top: 6px;
  }

  .web-no .web-news-describe {
    height: auto;
  }

  .web-news-info.hasInfo {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    margin-top: 22px;
  }

  @media screen and (max-width: 800px) {
    .web-news-img {
      width: 35vw;
      height: 20vw;
    }

    .web-news-message {
      width: -moz-calc(100% - 38vw);
      width: -webkit-calc(100% - 38vw);
      width: calc(100% - 38vw);
    }

    .web-news-title,
    .web-news-title.ellipsis {
      height: auto;
      line-height: 6vw;
      font-size: 16px;
    }

    .web-news-title.ellipsis {
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      white-space: normal;
    }

    .web-news-info,
    .web-news-info.hasInfo {
      height: 6vw;
      line-height: 6vw;
      font-size: 14px;
      margin-top: 2vw;
    }

    .web-news-info span {
      margin-left: 10px;
    }

    .web-no .web-news-info {
      margin-top: 3vw;
    }

    /* 有描述 */
    .web-news-describe {
      display: none;
    }

    .web-news-imgs-box.hasInfo .web-news-imgs,
    .web-news-imgs {
      width: 30vw;
      height: 16.8vw;
      margin-top: 3vw;
      margin-right: 1vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/List.vue